<template>
    <form class="dm-advanced-search-form" action="/search">
            
		<div class="dm-advanced-search-select dm-hide-mobile-flex" :class="{ 'dm-hide-desktop': isVisible }">
			<div class="form-group">
				<label for="bookCategory">Categories</label>

				<v-select 
					taggable 
					v-model="search.categories" 
					:options="taxonomies.categories" 
					v-on:option:selected="loadTaxonomies()"
					v-on:option:deselected="loadTaxonomies()"
					:class="{ 'disabled' : !categoryEnabled }"
					:disabled="!categoryEnabled"

					label="name"
					placeholder="Select Category"

					multiple>
				</v-select>
				<input type="hidden" name="categories" :value="actuallySelectedCategories">
				
			</div>
			<div class="form-group">
				<label for="bookSubCategory">Sub-categories</label>

					<!-- :class="{ 'disabled' : !subcategoryEnabled }"
					:disabled="!subcategoryEnabled"

					:class="{ 'disabled' : !genreEnabled }"
					:disabled="!genreEnabled"

					:class="{ 'disabled' : !themeEnabled }"
					:disabled="!themeEnabled"
					
					:class="{ 'disabled' : !authorEnabled }"
					:disabled="!authorEnabled" -->


				<v-select 
					taggable 
					v-model="search.sub_categories" 
					:options="taxonomies.subcategories" 
					v-on:option:selected="loadTaxonomies()"
					v-on:option:deselected="loadTaxonomies()"

					label="name"
					placeholder="Select Sub-categories"

					multiple>
				</v-select>
				<input type="hidden" name="sub_categories" :value="actuallySelectedSubCategories">

			</div>
			<div class="form-group">
				<label for="bookGenre">Genre</label>

				<v-select 
					taggable 
					v-model="search.genres" 
					:options="taxonomies.genres" 
					v-on:option:selected="loadTaxonomies()"
					v-on:option:deselected="loadTaxonomies()"

					label="name"
					placeholder="Select Genres"

					multiple>
				</v-select>
				<input type="hidden" name="genres" :value="actuallySelectedGenres">

			</div>
			<div class="form-group">
				<label for="bookThemes">Themes</label>

				<v-select 
					taggable 
					v-model="search.themes" 
					:options="taxonomies.themes" 
					v-on:option:selected="loadTaxonomies()"
					v-on:option:deselected="loadTaxonomies()"
					
					label="name"
					placeholder="Select Themes"

					multiple>
				</v-select>
				<input type="hidden" name="themes" :value="actuallySelectedThemes">

			</div>
			<div class="form-group">
				<label for="bookAuthors">Authors</label>

				<v-select 
					taggable 
					v-model="search.authors" 
					:options="taxonomies.authors" 
					
					label="name"
					placeholder="Select Authors"

					multiple>
				</v-select>
				<input type="hidden" name="authors" :value="actuallySelectedAuthors">

			</div>
		</div>

		<div class="dm-advanced-search-submit">
			<input class="form-control" type="text" name="keyword" v-model="search.keyword" placeholder="Keyword">
			<button class="btn dm-btn-padding">Search</button>
		</div>

		<div class="dm-advanced-search-reveal dm-hide-desktop text-center mt-4">
			<a class="btn btn-sm dm-btn-brand" @click="isVisible = !isVisible" v-show="!isVisible">Show Advanced Filters</a>
			<a class="btn btn-sm dm-btn-brand" @click="isVisible = !isVisible" v-show="isVisible">Hide Advanced Filters</a>
		</div>
		
	</form>
</template>

<script>
export default {
	props: ['keyword', 'categories', 'sub_categories', 'genres', 'themes', 'authors'],

	data() {
		return {
			search: {
				category: '',
				sub_category: '',
				genre: '',
				theme: '',
				author: '',
				// keyword: '',

				categories: [],
				sub_categories: [],
				genres: [],
				themes: [],
				authors: [],
				keyword: '',
			},
			taxonomies: {
				categories: [],
				subcategories: [],
				genres: [],
				themes: [],
				authors: [],
			},
			isVisible: false
		}
	},

	computed: {
		loadData() { // DEPRECATED
			let data = {
				categories: null
			};

			if (this.search.category != '') {
				data.category_id = this.search.category
			}

			return data;
		},

		loadTaxonomiesData() {
			let data = {
				categories: this.actuallySelectedCategories,
				subcategories: this.actuallySelectedSubCategories,
				genres: this.actuallySelectedGenres,
				themes: this.actuallySelectedThemes,
			};

			return data;
		},
		categoryEnabled() {
			return this.taxonomies.categories.length > 0;
		},
		subcategoryEnabled() {
			return this.taxonomies.subcategories.length > 0;
		},
		genreEnabled() {
			return this.taxonomies.genres.length > 0;
		},
		themeEnabled() {
			return this.taxonomies.themes.length > 0;
		},
		authorEnabled() {
			return this.taxonomies.authors.length > 0;
		},

		initialCategories() {
			if (!this.categories) return [];

			var initialCategories = [];
			var self = this;

			this.categories.forEach(function (currentCategoryId, currentCategoryIdKey) {

				var currentCategory = self.taxonomies.categories.filter(category => {
					return category.id == currentCategoryId
				})

				initialCategories.push(currentCategory[0]);
			});


			return initialCategories;
		},

		actuallySelectedCategories() {
			if (!this.search.categories) return [];

			var actualCategoryIds = [];

			this.search.categories.forEach(function (category, currentCategoryIdKey) {
				actualCategoryIds.push(category.id);
			});

			return actualCategoryIds;
		},

		initialSubCategories() {
			if (!this.sub_categories) return [];

			var initialSubCategories = [];
			var self = this;

			this.sub_categories.forEach(function (currentCategoryId, currentCategoryIdKey) {

				var currentSubCategory = self.taxonomies.subcategories.filter(subCategory => {
					return subCategory.id == currentCategoryId
				})

				initialSubCategories.push(currentSubCategory[0]);
			});


			return initialSubCategories;
		},

		actuallySelectedSubCategories() {
			if (!this.search.sub_categories) return [];

			var actualSubCategoryIds = [];

			this.search.sub_categories.forEach(function (subCategory, currentCategoryIdKey) {
				actualSubCategoryIds.push(subCategory.id);
			});

			return actualSubCategoryIds;
		},

		initialGenres() {
			if (!this.genres) return [];

			var initialGenres = [];
			var self = this;

			this.genres.forEach(function (currentCategoryId, currentCategoryIdKey) {

				var currentGenre = self.taxonomies.genres.filter(genre => {
					return genre.id == currentCategoryId
				})

				initialGenres.push(currentGenre[0]);
			});

			return initialGenres;
		},

		actuallySelectedGenres() {
			if (!this.search.genres) return [];

			var actualGenreIds = [];

			this.search.genres.forEach(function (genre, currentCategoryIdKey) {
				actualGenreIds.push(genre.id);
			});

			return actualGenreIds;
		},

		initialThemes() {
			if (!this.themes) return [];

			var initialThemes = [];
			var self = this;

			this.themes.forEach(function (currentThemeId, currentThemeIdKey) {

				var currentTheme = self.taxonomies.themes.filter(theme => {
					return theme.id == currentThemeId
				})

				initialThemes.push(currentTheme[0]);
			});

			return initialThemes;
		},

		actuallySelectedThemes() {
			if (!this.search.themes) return [];

			var actualThemeIds = [];

			this.search.themes.forEach(function (genre, currentCategoryIdKey) {
				actualThemeIds.push(genre.id);
			});

			return actualThemeIds;
		},

		initialAuthors() {
			if (!this.authors) return [];

			var initialAuthors = [];
			var self = this;

			this.authors.forEach(function (currentAuthorId, currentAuthorIdKey) {

				var currentAuthor = self.taxonomies.authors.filter(author => {
					return author.id == currentAuthorId
				})

				initialAuthors.push(currentAuthor[0]);
			});

			return initialAuthors;
		},

		actuallySelectedAuthors() {
			if (!this.search.authors) return [];

			var actualAuthorIds = [];

			this.search.authors.forEach(function (genre, currentCategoryIdKey) {
				actualAuthorIds.push(genre.id);
			});

			return actualAuthorIds;
		}

	},


	methods: {
		testEvent() {
			alert('testache');
		},

		loadTaxonomies() { 
			var self = this;

			axios.post('/api/advanced-search', this.loadTaxonomiesData)
				.then(function (response) {
					self.taxonomies.categories = response.data.categories;
					self.taxonomies.subcategories = response.data.subcategories;
					self.taxonomies.genres = response.data.genres;
					self.taxonomies.themes = response.data.themes;
					self.taxonomies.authors = response.data.authors;
				})
				.catch(function (error) {
					console.log(error);            
				});
		},

		initializeFields() {
			if (this.keyword) {
				this.search.keyword = this.keyword;
			}

			this.loadTaxonomies();
		},
		initializeTaxonomies() {
			this.search.categories     = this.initialCategories;
			this.search.sub_categories = this.initialSubCategories;
			this.search.genres         = this.initialGenres;
			this.search.themes         = this.initialThemes;
			this.search.authors        = this.initialAuthors;

			this.loadTaxonomies();
		}
	},
	mounted() {
		
		this.initializeFields();
		var self = this;

		setTimeout(function(){
			self.initializeTaxonomies();
		}, 500);
		setTimeout(function(){
			self.initializeTaxonomies();
		}, 1000);

	}
}
</script>
